import React from "react";
import { Tab } from "react-bootstrap";
import BroadcastEditorMessagePane from "./BroadcastEditorMessagePane";

export default function BroadcastEditorTabs({ values, setValues, SignatureModal }) {
  const handleMessageChange =
    (channel) =>
    (nextMessage, meta = {}) => {
      const nextValues = {
        ...values,
        Messages: values.Messages.map((m) =>
          m.Channel === channel ? nextMessage : m
        ),
      };

      if (meta.usedIn) {
        nextValues.BuilderConfiguration = {
          ...(values.BuilderConfiguration || {}),
          Tokens: [
            ...((values.BuilderConfiguration?.Tokens || []).filter(
              (t) => t.UsedIn !== meta.usedIn || t.Channel !== channel
            )),
            ...((meta.tokens || []).map((t) => ({
              ...t,
              UsedIn: meta.usedIn,
              Channel: channel,
            }))),
          ],
        };
      }

      setValues(nextValues);
    };

  return values.Messages.map((message) => (
    <Tab.Pane eventKey={message.Channel} key={message.Channel}>
      <BroadcastEditorMessagePane
        message={message}
        onChange={handleMessageChange(message.Channel)}
        isFileImport={values.IsFileImport}
        SignatureModal={SignatureModal}
      />
    </Tab.Pane>
  ));
}
